module.exports = __webpack_public_path__ + "img/img07.e5206280.png";